module.exports = __webpack_public_path__ + "img/header-memoireRingsFullSizeMemoires.13260f8.jpg";